import { Select } from "antd";
import { useSelector, useDispatch } from "react-redux";
import CommonAction from "stores/common/CommonAction";
import i18n from "../../../i18n";
import environment from "environment";

const CustomDropDown = () => {
  const dispatch = useDispatch();
  const language = useSelector((state) => state.common.currentLanguage);

  const handleChange = (value) => {
    if (value === 'German') {
      dispatch(CommonAction.setCurrentLanguage("German"));
      i18n.changeLanguage("de");
    } else if (value === 'English') {
      dispatch(CommonAction.setCurrentLanguage("English"));
      i18n.changeLanguage("en");
    } else if (value === 'French') {
      dispatch(CommonAction.setCurrentLanguage("French"));
      i18n.changeLanguage("fr");
    } else if (value === 'Italian') {
      dispatch(CommonAction.setCurrentLanguage("Italian"));
      i18n.changeLanguage("it");
    }
  };

  const options = (environment.APP_ENVIRONMENT === 'alabusTesting' || 
                   environment.APP_ENVIRONMENT === 'upquaiDemo' || 
                   environment.APP_ENVIRONMENT === 'development') 
    ? [
        { value: 'English', label: 'ENG' },
        { value: 'German', label: 'DE' },
        { value: 'French', label: 'FR' },
        { value: 'Italian', label: 'IT' },
      ]
    : [
        { value: 'English', label: 'ENG' },
        { value: 'German', label: 'DE' },
      ];

  return (
    <Select
      defaultValue={language}
      style={{ width: 77 }}
      onChange={handleChange}
      options={options}
    />
  );
};

export default CustomDropDown;
